import React from "react";
import { StarChartsListContainerProps } from "../../types/types";
import StarChartsListPresentation from "../../presentation/starChart.list.presentation/StarChartListPresentation";


const StarChartsListContainer: React.FC<StarChartsListContainerProps> = ({
  starChartsList,
  page,
  limit,
  setPage,
  setLimit,
  sort,
  onSort,
  onStarChartDelete,

}) => {

  return (
    <StarChartsListPresentation
    starChartsList={starChartsList}
      page={page}
      limit={limit}
      setPage={setPage}
      setLimit={setLimit}
      sort={sort}
      onSort={onSort}
      onStarChartDelete={onStarChartDelete}
    />
  )
}

export default StarChartsListContainer
